import { ISortable } from "app/helpers/sort";
import { SortItem, sortTypes, sortDirection } from "./member.dashboard.license.response";

export interface IAdminBrowseLogItem {
   ID: number;
   AmdinID: number;
   AdminName: string;
   MemberID: number;
   MemberName: string;
   LicenseID: number;
   LicenseKey: string;
   DateTimeCreated: Date;
}

export class AdminBrowseLogItem implements IAdminBrowseLogItem {
    ID: number;
    AmdinID: number;
    AdminName: string;
    MemberID: number;
    MemberName: string;
    LicenseID: number;
    LicenseKey: string;
    DateTimeCreated: Date;
}

export class AdminBrowseLogItemArray extends Array<AdminBrowseLogItem> implements ISortable {

    public LastSort = new SortItem;
    
    constructor(...items: AdminBrowseLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdminBrowseLogItemArray.prototype);
    }

    public static checkVariables(checkThis: AdminBrowseLogItemArray) {
        if (checkThis.LastSort == undefined) {
            checkThis.LastSort = new SortItem;
            checkThis.LastSort.SortType = sortTypes.ID;
            checkThis.LastSort.SortDirection = sortDirection.Unsorted;
        }
    }

}

